import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ontos_shell_menu = _resolveComponent("ontos-shell-menu")!

  return (_openBlock(), _createBlock(_component_ontos_shell_menu, {
    label: _ctx.$tt('workspace'),
    value: _ctx.workspace.title,
    loading: _ctx.loading,
    onToggle: _ctx.onToggle
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock(_component_v_list_item, {
          key: option.alias,
          to: _ctx.routeOf(option),
          title: option.title,
          active: option.alias === _ctx.workspace.alias,
          onClick: ($event: any) => (_ctx.onPick(option))
        }, _createSlots({ _: 2 }, [
          (option.closed)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_v_chip, {
                    size: "x-small",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tt('closed')), 1)
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["to", "title", "active", "onClick"]))
      }), 128)),
      (_ctx.options.length)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list_item, {
        to: {name: 'home'},
        title: _ctx.$tt('workspaces-all'),
        "prepend-icon": _ctx.HOME_ICON
      }, null, 8, ["title", "prepend-icon"])
    ]),
    _: 1
  }, 8, ["label", "value", "loading", "onToggle"]))
}